export class TableName {
  static SOCIAL_MEDIA = "socialMedia";
  static CONTACT_US = "contactUs";
  static NEWS = "news";
  static COLLABORATION = "collaboration";
  static USERS = "users";
  static BOUSERS = "boUsers";
  static ROLES = "roles";
  static NORMALRESERVATIONS = "normalReservations";
  static EVENTRESERVATIONS = "eventReservations";
  static RESERVATIONSETTINGS = "reservationSettings";
  static MODULES = "modules";
  static MAINTENANCE = "maintenance";
  static GENERAL = "general";
  static FEATURES = "features";
}
